/**
 * Created by guntherclaes on 09/05/2017.
 */
var visionText = angular.module('practicalExample', []);

visionText.directive('practicalExample', require('./js/visionText/visionText'));
visionText.directive('practicalExampleSection', require('./js/section/section'));
visionText.directive('practicalExampleVideo', require('./js/video/video'));
visionText.directive('practicalExampleVideoGroup', require('./js/videoGroup/videoGroup'));
visionText.directive('practicalExampleQuote', require('./js/quote/quote'));
visionText.directive('practicalExampleMusic', require('./js/music/music'));
visionText.directive('practicalExampleAttachments', require('./js/attachments/attachments'));
visionText.directive('practicalExampleSearchResultItem', require('./js/searchResultItem/searchResultItem'));

module.exports = visionText;



// WEBPACK FOOTER //
// ./web/js/module/practicalExample/index.js